<script setup>
import { shallowRef, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import UserStep from "./Partials/UserStep.vue";
import ProfilStep from "./Partials/ProfilStep.vue";
import AvatarStep from "./Partials/AvatarStep.vue";
import Stepper from "@Components/Stepper/Stepper.vue";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import Breadcrumb from "@Components/Breadcrumb.vue";
import LanguageMenu from "@Components/LanguageMenu.vue";

const stepper = ref();
const router = useRouter();
const { t: __ } = useI18n();
const [users, userRoles] = await Promise.all([
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_users")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
    new Promise((resolve, reject) => {
        useForm()
            .post("wordpress_user_roles")
            .then((response) => {
                resolve(response);
            })
            .catch((response) => {
                reject();
            });
    }),
]);

const form = useForm({
    mode: "attach",
    user_id: users[0]?.ID,
    language: getCurrentInstance().appContext.config.globalProperties.$app.default_locale,
    username: "",
    password: "",
    email: "",
    role: "administrator",
    first_name: "",
    last_name: "",
    description: "",
    age: "",
    job: "",
    writing_style: undefined,
    avatar: undefined,
    avatar_model: "flux_1_dev",
    avatar_custom_instructions: "",
});

const steps = ref([
    {
        key: "profil",
        status: "upcoming",
        next: {
            handler: "avatar",
            label: __("Générez un avatar"),
        },
        after: async () => {
            try {
                await form.post("personas_validate_profil_step");
                return true;
            } catch {
                return false;
            }
        },
        component: shallowRef(ProfilStep),
    },

    {
        key: "avatar",
        status: "upcoming",
        back: {
            handler: "profil",
        },
        next: {
            handler: "user",
            label: __("Associez un utilisateur"),
        },
        component: shallowRef(AvatarStep),
    },

    {
        key: "user",
        status: "upcoming",
        component: shallowRef(UserStep),
        next: {
            handler: () => submit(),
            label: __("Générer mon profil IA"),
        },
        back: {
            handler: "avatar",
        },
        after: async () => {
            try {
                await form.post("personas_validate_user_step");
                return true;
            } catch {
                return false;
            }
        },
        params: {
            users: users,
            userRoles: userRoles,
        },
    },
]);
const initialStep = ref("profil");

// --------------
// methods

const submit = () => {
    if (form.processing) return;

    form.post("personas_store")
        .then(() => {
            router.push({ name: "personas.index" });
        })
        .catch((err) => {});
};
// --------------
</script>

<template>
    <div>
        <Breadcrumb
            :pages="[
                {
                    name: __('Mes rédacteurs IA'),
                    href: { name: 'personas.index' },
                },
                { name: __('Nouveau rédacteur IA') },
            ]">
        </Breadcrumb>
        <Stepper ref="stepper" :steps="steps" v-model="form" :initial="initialStep">
            <template #before>
                <div class="bg-white border-b border-gray-300 dark:bg-gray-900 dark:border-gray-800">
                    <div class="mx-auto max-w-7xl px-4 py-5 lg:px-8 sm:p-6">
                        <div class="flex justify-end space-x-3">
                            <div class="w-48">
                                <LanguageMenu v-model="form.language" :z="1" :label="__('Langue')" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Stepper>
    </div>
</template>
